(function(window, angular) {
  "use strict";

	angular.module('service')
	.factory('configService', function() {
		var data = config;

		data.modelOptions = {
			debounce: {
				default: 500,
				blur: 250
			}
		};

		data.typeheadOptions = {
			wait_ms: 500,
			min_length: 2,
		};

		data.addTranslations = function(translations) {
			angular.forEach(translations, function(translation, key) {
				data.locale[key] = translation;
			});
		};

		data.translate = function(key) {
			return data.locale[key] || '';
		};
		return data;
	});
})(window, window.angular);
